<template>
  <div class="ventas-negociaciones-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroPeriodo="filtroPeriodo"
          :filtroNumero="filtroNumero"
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :cliente="cliente"
          :numero="numero"
          :numeroPuntoVenta="numeroPuntoVenta"
          :comprobanteTipo="comprobanteTipo"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card header="Registro de Ventas Negociadas">
            <b-table
              hover
              responsive="sm"
              class="registro"
              :busy="tableBusy"
              :items="ventas"
              :fields="ventasFields"
              @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaComprobante)="data">
                {{ data.item.fechaComprobante | fecha }}
              </template>
              <template v-slot:cell(fechaVencimiento)="data">
                {{ data.item.fechaVencimiento | fecha }}
              </template>
              <template v-slot:cell(total)="data">
                {{ data.item.total | moneda(data.item.moneda) }}
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  
                  <b-dropdown-item  @click.stop="eliminarNegociacion(data.item)"> <i class="fa fa-remove"></i>Borrar Negociación</b-dropdown-item>

                </b-dropdown>
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="totalRegistros" :per-page="registrosPorPagina" v-model="paginaActual" prev-text="Prev." next-text="Prox." />
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje :modalMsj="modalMsj" 
      :modalMensaje="modalMensaje" 
      @okAction="okAction" 
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './negociacionesFiltro.vue'
import Mensaje from '../shared/msjModal.vue'
import Confirm from '../shared/confirmModal.vue'
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import export_xls_ventas from '../../mixins/export_xls_ventas'
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'ventasNegociaciones/getField',
  mutationType: 'ventasNegociaciones/updateField',
})

export default {
  name: 'Ventas',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
    export_xls_ventas
  ],
  data: () => {
    return {
      ventaId: 0,
      tableBusy: false,

      labelCols: 3,
    }
  },
  computed: {
    ...mapFields([
      'ventas',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',

      'filtroPeriodo',
      'filtroNumero',
      'fechaDesde',
      'fechaHasta',
      'cliente',
      'numero',
      'numeroPuntoVenta',
      'comprobanteTipo',
      'sortByDescending',
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD')
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD')
    },
    paisId() {
      return parseInt(this.$store.getters['user/paisId'])
    },
    ventasFields() {
      let fields = [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.',
          sortable: true,
        },
        {
          key: 'cliente',
          sortable: true,
        },
        {
          key: 'proveedor',
          label: 'Agente',
          sortable: true,
        },
        {
          key: 'comprobante',
          sortable: true,
        },
        {
          key: 'total',
          // key: 'montoTotal',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ]

      return fields
    },
  },
  created() {
    this.getItems()
  },
  methods: {
    filtrar(filtro) {
      this.filtroPeriodo = filtro.filtroPeriodo
      this.filtroNumero = filtro.filtroNumero
      this.fechaDesde = filtro.fechaDesde
      this.fechaHasta = filtro.fechaHasta
      this.cliente = filtro.cliente
      this.numero = filtro.numero
      this.numeroPuntoVenta = filtro.numeroPuntoVenta
      this.comprobanteTipo = filtro.comprobanteTipo
      this.sortByDescending = filtro.sortByDescending
      this.paginaActual = 1
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true
      this.$store
        .dispatch('ventasNegociaciones/getVentasNegociaciones')
        .then(() => (this.tableBusy = false))
        .catch((error) => this.showErrorMsj(error))
    },
    consultar(item) {
      this.$router.push({ name: 'VentaNegociacionData', params: { id: item.id } })
    },
    eliminarNegociacion(item) {
      this.showModalConfirm('¿Desea borrar la negociación del comprobante seleccionado?', this.eliminarNegociacionComprobante.bind(this, item.id), 'Si', null, 'No')
    },
    eliminarNegociacionComprobante(ventaId) {
      this.showSpinner()
      this.$store.dispatch('ventas/deleteNegociacion', ventaId)
        .then(() => this.showModalMsj('La negociación del comprobante se eliminó con éxito', this.getItems, this.getItems, 'light'))
        .catch((error) => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },    
    // exportXls() {
    //   let clienteId = 0
    //   if (this.cliente) {
    //     if (this.cliente.id) {
    //       clienteId = this.cliente.id
    //     }
    //   }

    //   let params = {
    //     fechaDesde: this.fechaDesde,
    //     fechaHasta: this.fechaHasta,
    //     clienteId,
    //     numeroCertificado: this.numeroCertificado,
    //   }

    //   this.showSpinner()
    //   this.$store
    //     .dispatch('ventas/getRptVentas', params)
    //     .then(() => {
    //       let exportRpt = Boolean(false)
    //       let rptVentas = this.$store.getters['ventas/rptVentas']

    //       if (rptVentas) {
    //         if (rptVentas.length != 0) {
    //           exportRpt = Boolean(true)
    //         }
    //       }
    //       if (exportRpt) {
    //         this.exportXLSRptVentas(rptVentas)
    //       } else {
    //         this.showModalMsj('No hay datos para exportar', null, null, 'light')
    //       }
    //     })
    //     .catch((error) => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner())
    // },
  },
  watch: {
    paginaActual: function (newVal, oldVal) {
      if (newVal != 0 && oldVal != 0) {
        this.getItems()
      }
    },
  },
}
</script>

<style>
.ventas-negociaciones-list .registro table th {
  border-top: none;
}
.ventas-negociaciones-list .registro table td[aria-colindex='1'] {
  width: 10%;
}
.ventas-negociaciones-list .registro table td[aria-colindex='2'] {
  width: calc(30% - 30px);
}
.ventas-negociaciones-list .registro table td[aria-colindex='3'] {
  width: calc(30% - 30px);
}
.ventas-negociaciones-list .registro table td[aria-colindex='4'] {
  width: 15%;
}
.ventas-negociaciones-list .registro table td[aria-colindex='5'] {
  width: 15%;
}
.ventas-negociaciones-list .registro table td[aria-colindex='6'] {
  width: 60px;
}

.ventas-negociaciones-seleccionar-todo {
  display: inline-block;
  text-align: right;
  margin-bottom: 10px;
  padding-right: 30px;
}
.ventas-negociaciones-seleccionar-todo label {
  display: inline-block;
  font-size: 12px;
}
.ventas-negociaciones-seleccionar-todo .custom-checkbox {
  display: inline-block;
  width: 40px;
}
</style>
